module.exports = __webpack_public_path__ + "img/checkbox_icon.8c5ad0ba.svg";